module.exports = __webpack_public_path__ + "img/Slovenia.de89332c.gif";